import React from 'react'
import { FormattedMessage } from 'react-intl'
import Helmet from 'react-helmet'
import {
  Alert,
} from 'react-bootstrap'
import {
  NavbarTab
} from 'components/Navbar'
import LinkContainer from 'components/LinkContainer'
import Toasts from 'components/Toasts'
import withLeftSidebar from 'components/Sidebar/withLeftSidebar'
import { useLocation } from 'react-router'
import { connect } from 'react-redux'
import {
  showProfile,
  setIsSidebarVisible
} from 'store/redux/layout'
import {
  setUserId as setUserActivitiesId
} from 'store/redux/userActivities'
import { createStructuredSelector } from 'reselect'
import { currentUserSelector } from 'selectors/currentUser'
import queryString from 'query-string'
import Sidebar from 'routes/Home/Sidebar'
import styled from 'styled-components'

const TypedSidebar: React.FC<any> = Sidebar

const NoConnectionOverlay = styled.div`
  position: absolute;
  z-index: 100000;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(33, 33, 33, 0.5);
`

const NoConnectionAlert = styled(Alert)`
  position: absolute;
  right: 10px;
  top: 10px;
`

const HomeTab = styled(NavbarTab)`
  position: absolute;
  left: 5px;
  top: 5px;
  z-index: 13;
  border-radius: 20px;
  transition: left 250ms;

  & > * {
    padding: 0 6px;
  }

  .with-sidebar & {
    left: 50px;
  }

  .with-sidebar.sidebar-mobile-expanded & {
    left: 50px;
    border-radius: 5px;
  }

  @media (min-width: 1068px) {
    .with-sidebar.sidebar-pinned & {
      left: 50px;
      border-radius: 5px;
    }
  }
`

const HomeTabLogoWrapper = styled.div`
  display: flex;
  overflow: hidden;
  width: 28px;
  transition: width 250ms;

  .with-sidebar.sidebar-mobile-expanded & {
    width: 170px;
  }

  @media (min-width: 1068px) {
    .with-sidebar.sidebar-pinned & {
      width: 170px;
    }
  }
`

const HomeTabLogo = styled.img`
  max-height: 30px;
  max-width: 30px;
  margin-left: auto;
`

const HomeTabTitle = styled.img`
  max-height: 30px;
  margin-right: auto;

  .with-sidebar.sidebar-mobile-expanded & {
    display: block;
  }

  @media (min-width: 1068px) {
    .with-sidebar.sidebar-pinned & {
      display: block;
    }
  }
`

type StateProps = {
  noConnection: boolean
  isSidebarVisible: boolean
  currentUser: any
  unreadNotificationCount: number
}

type Props = StateProps

const Layout: React.FC<Props> = ({
  children,

  noConnection,
  isSidebarVisible,
  currentUser,
  unreadNotificationCount,
}) => {
  const location = useLocation()

  const embed = queryString.parse(location.search)?.embed

  let className: string = 'with-sidebar'
  if (isSidebarVisible) {
    className = `${className ? `${className} ` : ''}sidebar-mobile-expanded`
  }
  if (!currentUser.settings.miniMenu) {
    className = `${className ? `${className} ` : ''}sidebar-pinned`
  }
  if (embed) {
    className = `${className ? `${className} ` : ''}embed-${embed}`
  }

  return (
    <div id='layoutWrapper' className={className}>
      <Helmet
        defer={false}
        titleTemplate={unreadNotificationCount > 0 ? `(${unreadNotificationCount}) %s` : '%s'}
      />
      {noConnection &&
        <NoConnectionOverlay>
          <NoConnectionAlert bsStyle='danger'>
            <FormattedMessage id='NO_SERVER_CONNECTION' />
          </NoConnectionAlert>
        </NoConnectionOverlay>
      }
      <LinkContainer
        to={'/'}
      >
        <HomeTab>
          <HomeTabLogoWrapper>
            <HomeTabLogo src='/plugins/branding/logo.png' />
            <HomeTabTitle src='/plugins/branding/title.png' />
          </HomeTabLogoWrapper>
        </HomeTab>
      </LinkContainer>
      <TypedSidebar />
      {children}
      <Toasts />
    </div>
  )
}

const selector = createStructuredSelector<any, {}, StateProps>({
  noConnection: state => state.kanbo.layout.noConnection,
  isSidebarVisible: state => state.kanbo.layout.isSidebarVisible,
  currentUser: currentUserSelector,
  unreadNotificationCount: state => state.kanbo.notifications.unreadCount,
})

export default withLeftSidebar(
  connect<StateProps>(
    selector,
    {
      showProfile,
      setIsSidebarVisible,
      setUserActivitiesId,
    },
  )(Layout)
)
